import React, { Suspense, useEffect, useState } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useAuthContext } from "./hooks/useAuthContext";
import LoadingPage from "./pages/LoadingPage";
import InvoiceDetails from "./components/user-dashboard/Invoice/invoice-details";
import { CartProvider } from "./components/Room/CartContext"; // Import the CartProvider

// Lazy load pages and components
const Landing = React.lazy(() => import("./pages/Landing"));
const UserDashBoard = React.lazy(() => import("./components/user-dashboard"));
const About = React.lazy(() => import("./pages/About"));
const Blog = React.lazy(() => import("./pages/Blog"));
const BookingCheckout = React.lazy(() => import("./pages/BookingCheckout"));
const Checkout = React.lazy(() => import("./pages/Checkout"));
const Contact = React.lazy(() => import("./pages/Contact"));
const Events = React.lazy(() => import("./pages/Events"));
const Restaurant = React.lazy(() => import("./pages/Restaurant"));
const Room = React.lazy(() => import("./pages/Room"));
const Services = React.lazy(() => import("./pages/Services"));
const SalonSpa = React.lazy(() => import("./components/SalonSpa/SalonSpa"));
const BlogPost = React.lazy(() => import("./pages/BlogPost"));
const BlogPostDesc = React.lazy(() => import("./components/Blog/BlogPostDesc"));
const EventDesc = React.lazy(() => import("./components/Events/EventDesc"));
const Dashboard = React.lazy(() => import("./pages/Dashboard"));
const EditUser = React.lazy(() => import("./pages/EditUserProfile"));
const Booking = React.lazy(() => import("./pages/Booking"));
const BookingDesc = React.lazy(() => import("./pages/BookingDesc"));
const Address = React.lazy(() => import("./pages/Address"));
const PaymentMethods = React.lazy(() => import("./pages/PaymentMethods"));
const Login = React.lazy(() => import("./pages/Login"));
const SignUp = React.lazy(() => import("./pages/Signup"));
const RoomDetails = React.lazy(() => import("./components/Room/RoomDetails"));
const VerifyPayment = React.lazy(() => import("./components/CheckoutPage/PaystackPage"));
const InvoicePage = React.lazy(() => import("./pages/Invoice"));
// const Cart = React.lazy(() => import("./components/Cart/Cart"));

function App() {
  const [loading, setLoading] = useState(false);
  const { user } = useAuthContext();

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  return (
    <>
      {loading ? (
        <LoadingPage />
      ) : (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <CartProvider> {/* Wrap the app with CartProvider */}
            <Routes>
              <Route
                path="/"
                element={
                  <Suspense fallback={<LoadingPage />}>
                    <Landing />
                  </Suspense>
                }
              />
              <Route
                path="/About"
                element={
                  <Suspense fallback={<LoadingPage />}>
                    <About />
                  </Suspense>
                }
              />
              <Route
                path="/Blog"
                element={
                  <Suspense fallback={<LoadingPage />}>
                    <Blog />
                  </Suspense>
                }
              />
              <Route
                path="/BookingCheckout"
                element={
                  <Suspense fallback={<LoadingPage />}>
                    <BookingCheckout />
                  </Suspense>
                }
              />
              <Route
                path="/Checkout/:id"
                element={
                  user ? (
                  <Suspense fallback={<LoadingPage />}>
                    <Checkout />
                  </Suspense>
                
                ) : (
                  <Navigate to="/" />
                )
              }
            />
            {/* <Route
              path="/invoice/:id"
              element={
                user ? (
                  <Suspense fallback={<LoadingPage />}>
                    <Cart />
                  </Suspense>
                  ) : (
                  <Navigate to="/" />
                )
                }
              /> */}
               {/* <Route
                path="/Cart/:id"
                element={
                  <Suspense fallback={<LoadingPage />}>
                    <Cart />
                  </Suspense>
                }
              /> */}
              <Route
                path="/Contact"
                element={
                  <Suspense fallback={<LoadingPage />}>
                    <Contact />
                  </Suspense>
                }
              />
              <Route
                path="/Events"
                element={
                  <Suspense fallback={<LoadingPage />}>
                    <Events />
                  </Suspense>
                }
              />
              <Route
                path="/Restaurant"
                element={
                  <Suspense fallback={<LoadingPage />}>
                    <Restaurant />
                  </Suspense>
                }
              />
              <Route
                path="/Room"
                element={
                  <Suspense fallback={<LoadingPage />}>
                    <Room />
                  </Suspense>
                }
              />
              <Route
                path="/SalonSpa"
                element={
                  <Suspense fallback={<LoadingPage />}>
                    <SalonSpa />
                  </Suspense>
                }
              />
              <Route
                path="/Services"
                element={
                  <Suspense fallback={<LoadingPage />}>
                    <Services />
                  </Suspense>
                }
              />
              <Route
                path="/EventDesc/:id"
                element={
                  <Suspense fallback={<LoadingPage />}>
                    <EventDesc />
                  </Suspense>
                }
              />
              <Route
                path="/BlogPost"
                element={
                  <Suspense fallback={<LoadingPage />}>
                    <BlogPost />
                  </Suspense>
                }
              />
              <Route
                path="/Dashboard"
                element={
                  user ? (
                    <Suspense fallback={<LoadingPage />}>
                      <Dashboard />
                    </Suspense>
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />
              <Route
                path="/Booking"
                element={
                  user ? (
                    <Suspense fallback={<LoadingPage />}>
                      <Booking />
                    </Suspense>
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />
              <Route
                path="/Address"
                element={
                  user ? (
                    <Suspense fallback={<LoadingPage />}>
                      <Address />
                    </Suspense>
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />
              <Route
                path="/Login"
                element={
                  <Suspense fallback={<LoadingPage />}>
                    <Login />
                  </Suspense>
                }
              />
              <Route
                path="/Signup"
                element={
                  <Suspense fallback={<LoadingPage />}>
                    <SignUp />
                  </Suspense>
                }
              />
              <Route
                path="/RoomDetails/:id"
                element={
                  <Suspense fallback={<LoadingPage />}>
                    <RoomDetails />
                  </Suspense>
                }
              />
              <Route
                path="/PaymentMethods"
                element={
                  <Suspense fallback={<LoadingPage />}>
                    <PaymentMethods />
                  </Suspense>
                }
              />
              <Route
                path="/VerifyPayment"
                element={
                  <Suspense fallback={<LoadingPage />}>
                    <VerifyPayment />
                  </Suspense>
                }
              />
              <Route
                path="/BookingDescription/:bookingId"
                element={
                  <Suspense fallback={<LoadingPage />}>
                    <BookingDesc />
                  </Suspense>
                }
              />
              <Route
                path="/EditUserProfile"
                element={
                  user ? (
                    <Suspense fallback={<LoadingPage />}>
                      <EditUser />
                    </Suspense>
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />
              <Route
                path="/Invoice"
                element={
                  user ? (
                    <Suspense fallback={<LoadingPage />}>
                      <InvoicePage />
                    </Suspense>
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />
              <Route
                path="/Invoice/:id"
                element={
                  user ? (
                    <Suspense fallback={<LoadingPage />}>
                      <InvoiceDetails />
                    </Suspense>
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />
              <Route
                path="/BlogPostDesc/:id"
                element={
                  <Suspense fallback={<LoadingPage />}>
                    <BlogPostDesc />
                  </Suspense>
                }
              />
              <Route
                path="/user/*"
                element={user ? <UserDashBoard /> : <Login />}
              />
            </Routes>
          </CartProvider>
        </LocalizationProvider>
      )}
    </>
  );
}

export default App;
